import type { Locale, MessageDictionary } from '../types';
import { enMessages } from './en';
import { zhCNMessages } from './zhCN';

export const messages: Record<Locale, Partial<MessageDictionary>> = {
  en: enMessages,
  'zh-CN': zhCNMessages,
};
